module.exports = __webpack_public_path__ + "static/media/NodeJS.6d66c427.png";